import React from "react";
import styled from "styled-components";
import ConfettiCelebration from "./ConfettiCelebration";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const PopupContainer = styled.div`
  background: #fff;
  padding: 2rem;
  border-radius: 16px;
  text-align: center;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
`;

const BadgeImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  font-size: 1.25rem;
  font-weight: bold;
  color: #333;
`;

const Popup = ({ trigger, imageSrc, badgeNumber }) => {
  if (!trigger) return null;

  const encouragingMessages = {
    1: "Great job finishing Module 1! Every step forward builds momentum 🚀",
    2: "Awesome work on Module 2! You're getting the hang of this 💪",
    3: "Module 3 complete — you’re making real progress! Keep going 🔥",
    4: "Fantastic! Module 4 down. You’re halfway to mastery 🎯",
    5: "You’ve crushed Module 5! Keep pushing, you’re doing amazing 🌟",
    6: "Module 6 done! The finish line is getting closer 🏁",
    7: "Incredible — Module 7 complete! You’re unstoppable ⚡",
  };

  return (
    <Overlay>
      <PopupContainer>
        <BadgeImage src={imageSrc} alt="Badge" />
        <Message>{encouragingMessages[badgeNumber]}</Message>
      </PopupContainer>
       <ConfettiCelebration trigger={true} onDone={() => null} />
    </Overlay>
  );
};

export default Popup;
